import { render, staticRenderFns } from "./modalRdasConsulta.vue?vue&type=template&id=0146baaf&scoped=true"
import script from "./modalRdasConsulta.vue?vue&type=script&lang=js"
export * from "./modalRdasConsulta.vue?vue&type=script&lang=js"
import style0 from "./modalRdasConsulta.vue?vue&type=style&index=0&id=0146baaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0146baaf",
  null
  
)

export default component.exports